import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { NgbDropdownModule, PlacementArray } from '@ng-bootstrap/ng-bootstrap';
import { MbsSize } from '../../utils';
import { ButtonComponent } from '../button.component';

@Component({
  selector: 'mbs-dropdown-button, [mbs-dropdown-button]',
  templateUrl: 'dropdown-button.component.html',
  host: {
    '[class.-isCtrl]': 'isCtrl()',
    '[class.-disabled]': 'disabledOrLoading()',
    '[class.-isBlock]': 'block()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdownModule, NgClass, NgTemplateOutlet],
  providers: [{ provide: ButtonComponent, useExisting: DropdownButtonComponent }]
})
export class DropdownButtonComponent extends ButtonComponent {
  protected readonly MbsSize = MbsSize;

  public readonly dropdownParentClasses = input<string>('');
  public readonly dropdownTemplate = input.required<TemplateRef<unknown>>();
  public readonly dropdownShowArrow = input<boolean>(false);
  public readonly dropdownContainer = input<null | 'body'>('body');
  public readonly dropdownSize = input<MbsSize.lg | MbsSize.sm | MbsSize.xs>(null);
  public readonly dropdownDisplay = input<'dynamic' | 'static'>('dynamic');
  public readonly dropdownPlacement = input<PlacementArray>('bottom-left bottom-right top-left top-right');
  public readonly dropdownHideIcon = input<boolean>(false);
}
